export default {
  createHeader: 'Vytvoriť štítok udalosti',
  editHeader: 'Upraviť štítok udalosti',
  duplicateDisplayName: 'Štítok s týmto názvom už existuje.',
};
